import { ComponentType, forwardRef, useState } from 'react'
import { Tooltip } from 'antd'
import { TooltipPlacement } from 'antd/lib/tooltip'

interface WithTooltipProps<V> {
	showTooltip?: boolean
	placeholder?: React.ReactNode
	tooltipText?: React.ReactNode
	tooltipPlacement?: TooltipPlacement
	isTooltipWithText?: boolean
	value: V
}

export const withTooltip = <P extends {}, V>(Component: ComponentType<P>) =>
	forwardRef(
		(
			{
				showTooltip = false,
				tooltipText,
				tooltipPlacement,
				isTooltipWithText,
				...props
			}: P & WithTooltipProps<V>,
			ref
		) => {
			const [isOpenDropdown, setIsOpenDropdown] = useState<boolean>(false)

			return showTooltip ? (
				<Tooltip
					title={tooltipText ?? props.placeholder}
					placement={tooltipPlacement ?? 'topLeft'}
					{...(isOpenDropdown || (!!props.value && !isTooltipWithText)
						? { open: false }
						: {})}
					children={
						<Component
							{...(props as P)}
							ref={ref}
							onDropdownVisibleChange={(open: boolean) => {
								setIsOpenDropdown(open)
							}}
						/>
					}
				/>
			) : (
				<Component {...(props as P)} ref={ref} />
			)
		}
	)
